<template>
    <div v-loading="loading">
        <EnterEmailAddress @sendConfirmEmailSuccess="showConFirmEmail" ref="enterEmailAddress"></EnterEmailAddress>
        <SendEmailResetPassword ref="sendEmailResetPassword"></SendEmailResetPassword>
    </div>
</template>

<script>
    import EnterEmailAddress from "./components/EnterEmailAddress";
    import SendEmailResetPassword from "./components/SendEmailResetPassword";
    import ChangePasswordAfterConfirm from "./components/ChangePasswordAfterConfirm";

    export default {
        name: "ResetPassword",
        components: {EnterEmailAddress, SendEmailResetPassword, ChangePasswordAfterConfirm},
        data() {
            return {
                loading: false,
            }
        },
        methods: {
            showConFirmEmail(endUserEmail) {
                this.$refs['enterEmailAddress'].setDisable(true);
                this.$refs['sendEmailResetPassword'].setDisable(false);
                this.$refs['sendEmailResetPassword'].setEndUserMail(endUserEmail);
            }
        }
    }
</script>

<style scoped>

</style>